import React, { useState } from "react";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
export default function AddPhotoModal({ addPhotoHolder, isOpenPhotoModal, closePhotoModal }) {
  const [width, setWidth] = useState(200);
  const [height, setHeight] = useState(200);
  const handleSubmit = (e) => {
    e.preventDefault();
     const data = {
        width:width,
        height:height
     }
    addPhotoHolder(data);
    closePhotoModal();
  };
  return (
    <div>
     
      <Dialog fullWidth open={isOpenPhotoModal} onClose={closePhotoModal} aria-labelledby="form-dialog-title" maxWidth={`xs`} >
        <DialogTitle id="form-dialog-title" className="modal-title">Add Photo Box</DialogTitle>
        <form onSubmit={(e) => handleSubmit(e)}>
        <DialogContent >
          <TextField
            autoFocus
            margin="dense"
            id="width"
            label="Width"
            type="number"
            fullWidth
            onChange={(e) => setWidth(e.target.value)}
          />
           <TextField
            autoFocus
            margin="dense"
            id="height"
            label="Height"
            type="number"
            fullWidth
            onChange={(e) => setHeight(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={closePhotoModal} variant="contained" color="secondary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}